import { analyticsSortRecord } from '../../types/analyticsSortRecord';
export const getAnalyticsContainedData = ({ portal, place, classifiedIds, order, page, totalCount, }) => {
    const analyticsClassifieds = classifiedIds.map((classifiedId, index) => ({
        classifiedId,
        rank: index + 1,
        pagenumber: page,
        results: totalCount,
        sorttype: analyticsSortRecord[order],
    }));
    return { place, portal, classifieds: analyticsClassifieds };
};
